import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import { deleteCoupon } from "src/redux/coupon/couponActions";
import { Coupon } from "src/redux/coupon/couponReducer";

interface Props {
  onClose: () => void;
  data: Coupon;
  couponGroupUuid: string;
}

export const DeleteCouponModal: React.FC<Props> = (props) => {
  const { onClose, data, couponGroupUuid } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const confirmDeleting = async () => {
    setLoading(true);
    dispatch(deleteCoupon(data.uuid, couponGroupUuid));
    onClose();
  };

  return (
    <RemoveModal
      onClose={onClose}
      objectNames={[data.code]}
      removeFunction={confirmDeleting}
      loading={loading}
    />
  );
};
